import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    easyUser: (state) => state.easyUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
  ...mapGetters('authfack', ['getCurrentUser', 'easyUser']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
  }),
}
export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register'])

export const layoutMethods = mapActions('layout', ['changeLayoutType'])

export const authFackMethods = mapActions('authfack', [
  'login',
  'loginSocial',
  'registeruser',
  'logout',
  'getCurrentUser',
  'resetPassword',
  'changePassword',
  'getApplication',
])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export function hidderComponent(item, isService) {
  if (!item) {
    return true
  }
  let userObject = JSON.parse(localStorage.getItem('user_object'))
  let token = localStorage.getItem('user_token')
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = JSON.parse(
    decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join(''),
    ),
  )

  if (isService) {
    return jsonPayload.services.includes(item)
  } else {
    return userObject.permissions.includes(item)
  }
}

export function getCompanyFromJwtToken() {
  let token = localStorage.getItem('user_token')
  if (!token) {
    return null
  }
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = JSON.parse(
    decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) { return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2) })
        .join('')
    ),
  )
  console.log('jsonPayload', jsonPayload)
  return jsonPayload["clt-ref"]
}
